const faqsReducer = (state = false, action) => {
  switch(action.type){
    case 'GET_FAQS_SUCCESS':
      return action.payload;
    default:
       return state;
  }
};

export default faqsReducer;